import { render } from "./SourceGroupCard.vue?vue&type=template&id=df81bfb2"
import script from "./SourceGroupCard.vue?vue&type=script&lang=js"
export * from "./SourceGroupCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__